module.exports = __webpack_public_path__ + "static/img/03.f660824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/03.png
// module id = ocIF
// module chunks = 0